<template>
    <div class="container-window mt-3 mr-3 border bd-e4 p-3">
        <HeaderWindow @onClose="onClose" :title="title" :show_calll="true" />
        <CallLogsTable @getCallLogs="getCallLogs" :current_page="current_page" :logs="call_logs"></CallLogsTable>
    </div>
</template>
<script>
import HeaderWindow from '../../components/Diseases/HeaderWindow.vue'
import CallLogsTable from '../../components/VideoCall/CallLogsTable.vue'
export default {

  name: 'CallLogs',
  components: {HeaderWindow, CallLogsTable},
  data () {
    return {
      title: 'lịch sử cuộc gọi',
      call_logs: null,
      person_diseases_id: '',
      current_page: 1,
      user_id: null
    }
  },
  mounted () {
    let self = this
    self.person_diseases_id = self.$route?.params?.id
    self.getPersonsDiseasesDetail()
  },
  methods: {
    onClose () {
      this.$router.push({ path: `/doctor/diseases/${this.$route?.params?.id}/activity` })
    },
    async getPersonsDiseasesDetail () {
      let self = this
      try {
        await self.$rf.getRequest('DoctorRequest').getPersonsDiseasesDetail(self.$route?.params?.id).then(res => {
          if (res && res.data) {
            console.log('res.data', res.data)
            self.user_id = res.data?.user?.id
            self.getCallLogs()
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async getCallLogs () {
      let self = this
      self.current_page = parseInt(self.$route.query.page) || 1
      let params = {
        person_diseases_id: self.$route?.params?.id,
        user_id: this.user_id,
        limit: 13,
        sort: 'updated_at',
        sort_by: 'desc',
        page: self.current_page
      }
      try {
        await self.$rf.getRequest('DoctorRequest').getCallLogs(params).then(res => {
          if (res && res.data) {
            self.call_logs = res.data
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    formatDateDMY (date) {
      return window.moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
<style lang="css" scoped>
</style>